import { render } from "./OwnerDetail.vue?vue&type=template&id=0c4ed530&scoped=true&ts=true"
import script from "./OwnerDetail.vue?vue&type=script&lang=ts"
export * from "./OwnerDetail.vue?vue&type=script&lang=ts"

import "./OwnerDetail.vue?vue&type=style&index=0&id=0c4ed530&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4ed530"]])

export default __exports__